import { ShowGalleryPictureModalContext } from '@/contexts'
import { useContext } from 'react'

export const useShowGalleryModalContext = () => {
  const context = useContext(ShowGalleryPictureModalContext)

  if (!context) throw new Error('useShowGalleryModalContext has to be wrapped by ShowGalleryModalContextProvider')

  return context
}
